import { SmartOrderInboundHistoryOrderBy } from '@/types';
import { SmartOrderStatus } from '@/enums';

export interface OrderInboundsOrderListFilterFormValues {
  filter: InboundListFilter;
  search: string;
}

export const FILTER_OPEN_STATUSES: Set<SmartOrderStatus> = new Set([
  SmartOrderStatus.NO_RESULTS,
  SmartOrderStatus.NOT_VERIFIED,
  SmartOrderStatus.PENDING,
  SmartOrderStatus.UNKNOWN_CONTACT,
]);

export const FILTER_CLOSED_STATUSES: Set<SmartOrderStatus> = new Set([
  SmartOrderStatus.SUBMITTED,
  SmartOrderStatus.REJECTED,
]);

export enum InboundListFilter {
  All = 'ALL',
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export const INBOUND_LIST_FILTERS = [
  InboundListFilter.Open,
  InboundListFilter.Closed,
  InboundListFilter.All,
] as const;

export const FILTER_ALL_STATUSES: Set<SmartOrderStatus> = new Set([
  ...FILTER_OPEN_STATUSES,
  ...FILTER_CLOSED_STATUSES,
]);

export const FILTER_STATUS_SETS: Record<
  InboundListFilter,
  Set<SmartOrderStatus>
> = {
  [InboundListFilter.Open]: FILTER_OPEN_STATUSES,
  [InboundListFilter.Closed]: FILTER_CLOSED_STATUSES,
  [InboundListFilter.All]: FILTER_ALL_STATUSES,
};

/**
 * Sort options offered by the filter panel, in the Figma's order. Labels are
 * held as i18n keys rather than resolved strings so they pick up the active
 * locale when the panel renders, not when this module is first evaluated.
 */
export const INBOUND_SORT_OPTIONS: {
  labelKey: string;
  value: SmartOrderInboundHistoryOrderBy;
}[] = [
  {
    labelKey: 'order_inbound.filter_panel.sort_newest_first',
    value: SmartOrderInboundHistoryOrderBy.NewestFirst,
  },
  {
    labelKey: 'order_inbound.filter_panel.sort_oldest_first',
    value: SmartOrderInboundHistoryOrderBy.OldestFirst,
  },
  {
    labelKey: 'order_inbound.filter_panel.sort_closest_cutoff',
    value: SmartOrderInboundHistoryOrderBy.ClosestCutoff,
  },
];

/** An assignee the user can filter by, as rendered in the panel's checkbox list. */
export interface InboundAssigneeOption {
  employeeUUID: string;
  /** Already resolved for display -- override name, with the "(Me)" suffix applied. */
  label: string;
}
